var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpgrade(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.86656 10.5933L9.74656 8.83335C9.86656 8.59335 10.1866 8.35335 10.4532 8.31335L12.0466 8.04669C13.0666 7.87335 13.3066 7.14002 12.5732 6.40668L11.3332 5.16668C11.1266 4.96002 11.0066 4.55335 11.0732 4.26002L11.4266 2.72002C11.7066 1.50668 11.0599 1.03335 9.98657 1.66668L8.49322 2.55335C8.21989 2.71335 7.7799 2.71335 7.50657 2.55335L6.01322 1.66668C4.93989 1.03335 4.29322 1.50668 4.57322 2.72002L4.92657 4.26002C4.99324 4.54668 4.87323 4.95335 4.66656 5.16668L3.42657 6.40668C2.69324 7.14002 2.93322 7.88002 3.95322 8.04669L5.54657 8.31335C5.81323 8.36002 6.13323 8.59335 6.25323 8.83335L7.13324 10.5933C7.60657 11.5467 8.39322 11.5467 8.86656 10.5933Z",
    stroke: "#29282C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10.0001V14.6667",
    stroke: "#29282C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.0001V14.6667",
    stroke: "#29282C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.3334V14.6667",
    stroke: "#29282C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgrade);
export default __webpack_public_path__ + "static/media/upgrade.ec38a160302dcc146b9b67908e0ba0bc.svg";
export { ForwardRef as ReactComponent };